var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 91,
    viewBox: "0 0 115 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0744 21.6667L56.9217 21L55.4188 21.3442L55.6241 22.2408L45.0085 72.6652L46.5173 72.9828L56.4451 25.8256L66.9827 71.8397L68.4856 71.4955L57.2027 22.2268L57.3102 21.7164L57.0744 21.6667Z",
    fill: "#7ABB5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4969 46.3795L75.8423 46.2816L75.6723 45.6818L75.82 45.094L75.4815 45.0089L75.4218 44.7982L75.0559 44.9019L40.5544 36.2284L40.1785 37.7237L72.0834 45.7445L38.9999 55.122L39.4204 56.6054L75.0798 46.4977L75.4441 46.5893L75.4969 46.3795Z",
    fill: "#7ABB5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 113,
    height: 59,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77 1L77 91",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114 1L114 61",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 1L-4.76837e-07 1",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 0L38 91",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90L78 90",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.34bb755cf7e2a61ff58cfe0a9f8d4a28.svg";
export { ForwardRef as ReactComponent };